import { useState } from 'react';
import Card from '../components/Card';
import PDFViewerModal from '../components/PDFViewerModal';

const pdfFiles = [
  { name: '1・企画書作成AI編_SNSマーケティング基本作成AIアプリ', url: '/download/GPTsManual1.pdf' },
  { name: '2・販売戦略案作成AI_SNSマーケティング基本作成AIアプリ', url: '/download/GPTsManual2.pdf' },
  { name: '3・LPプロンプト作成AI_SNSマーケティング基本作成AIアプリ', url: '/download/GPTsManual3.pdf' },
  { name: '4・LP作成AI_SNSマーケティング基本作成AIアプリ', url: '/download/GPTsManual4.pdf' },
  { name: '5・SNS投稿アシスタントAI', url: '/download/GPTsManual5.pdf' },
  { name: '6・GAレポート作成アシスタントAI編', url: '/download/GPTsManual6.pdf' },
];

const Manual = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState('');

  const openModal = (pdfUrl) => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    //console.log('openModal called', pdfUrl);
    setSelectedPdf(pdfUrl);
    setIsModalOpen(true);
  };
  
  

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPdf('');
  };

  return (
    <div className="page">
      <h1 className="title">ChatGPT活用マニュアル</h1>

      <Card title="ChatGPT活用マニュアル">
        <p>話題の生成AI「ChatGPT」を業務や学習にどう活かすか、具体例を交えたマニュアルをご提供。</p>

        {/* ここにiframe埋め込み */}
        <div className="iframe-container" style={{ margin: '20px 0' }}>
          <iframe
            src="https://myou-kou.com/GPTs/"
            title="GPTs活用ページ"
            width="100%"
            height="1000px"
            style={{ border: '1px solid #ccc', borderRadius: '8px' }}
          ></iframe>
        </div>

        {/* PDF リスト */}
        <ul className="link-list">
          {pdfFiles.map((file, index) => (
            <li key={index}>
              <button
                className="link-button"
                onClick={() => openModal(file.url)}
              >
                {file.name}
              </button>
            </li>
          ))}
        </ul>
      </Card>

      <PDFViewerModal isOpen={isModalOpen} onClose={closeModal} pdfUrl={selectedPdf} />
    </div>
  );
};

export default Manual;
